// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  roundId: __t.u64().primaryKey().name("round_id"),
  settlementId: __t.u64().name("settlement_id"),
  commodity: __t.string(),
  avgPrice: __t.f32().name("avg_price"),
  volume: __t.i32(),
  unfilled: __t.i32(),
  epoch: __t.u32(),
  at: __t.timestamp(),
});
